import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import SiteLayout from './components/SiteLayout';
import Home from './pages/Home';
import Tracking from './pages/Tracking';
import Expedier from './pages/Expedier';
import PaiementSansContact from './pages/PaiementSansContact';
import Solutions from './pages/Solutions';
import Fonctionnalites from './pages/Fonctionnalites';
import PourQui from './pages/PourQui';
import Tarifs from './pages/Tarifs';
import DevenirRelais from './pages/DevenirRelais';
import Partenaires from './pages/Partenaires';
import APropos from './pages/APropos';
import Support from './pages/Support';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';

// Composant pour scroller vers le haut lors du changement de route
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/PalSans_contact" element={<PaiementSansContact />} />
            <Route path="/*" element={
              <SiteLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/expedier" element={<Expedier />} />
                  <Route path="/tracking" element={<Tracking />} />
                  <Route path="/solutions" element={<Solutions />} />
                  <Route path="/fonctionnalites" element={<Fonctionnalites />} />
                  <Route path="/pour-qui" element={<PourQui />} />
                  <Route path="/tarifs" element={<Tarifs />} />
                  <Route path="/devenir-relais" element={<DevenirRelais />} />
                  <Route path="/partenaires" element={<Partenaires />} />
                  <Route path="/a-propos" element={<APropos />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                </Routes>
              </SiteLayout>
            } />
          </Routes>
        </Router>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10B981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#EF4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
